package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Display.FLEX
import com.downdogapp.FlexDirection.ROW
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.View
import com.downdogapp.client.controllers.AlertViewController
import com.downdogapp.client.widget.*

actual class AlertView actual constructor(controller: AlertViewController) : TopLevelView(), View {

  override val root = controllerView {
    bg = background(blur = false, image = null) {
      bgColor = Color.black(0.5)
    }

    fg = foreground {
      display = FLEX
      flexDirection = ROW
      justifyContent = JustifyContent.CENTER
      alignItems = AlignItems.CENTER

      verticalFlexBox {
        bgColor = Color.WHITE
        borderRadius = px(20)
        padding = px(10)
        margin = px(20)

        controller.title?.let {
          label(controller.title, 16, FontWeight.SEMIBOLD, Color.BLACK) {
            marginTop = px(25)
            marginHorizontal = px(25)
          }
        }
        label(controller.message, 12, color = Color.BLACK) {
          marginTop = if (controller.title != null) px(10) else px(25)
          marginHorizontal = px(25)
        }
        horizontalFlexBox {
          marginTop = px(20)
          marginBottom = px(25)
          marginHorizontal = px(25)

          controller.negativeButton?.title?.let {
            roundedTextButton(
              it,
              bgColor = Color.ALT_ROUNDED_BUTTON_GREY_BACKGROUND,
              clickFn = controller::onNegativeButtonClicked
            ) {
              marginRight = px(10)
            }
          }
          controller.positiveButton.title?.let {
            roundedTextButton(
              it,
              clickFn = controller::onPositiveButtonClicked
            )
          }
        }
      }
    }
  }
}
